import { Reducer } from 'redux';
import { persistReducer, createMigrate } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import {
  ADDRESSES_REQUEST,
  ADDRESSES_SUCCESSFUL,
  ADDRESSES_FAILURE,
  ADDRESSES_SELECT,
  ADDRESSES_EDIT,
  ADDRESSES_CLEAR_SELECT,
  ADDRESSES_LOCATION,
} from 'action-creators/addresses';
import { RESET } from 'action-creators/generic';
import { AddressSearch } from 'models/address';

export interface AddressesState {
  isLoading: boolean;
  lastSearch: google.maps.places.AutocompletePrediction | null;
  search: AddressSearch;
  error: string | null;
  selected: google.maps.places.AutocompletePrediction | null;
  edit: string;
  useLocation: boolean;
}

const initialState: AddressesState = {
  isLoading: false,
  lastSearch: null,
  search: { keyword: null, results: [] },
  error: null,
  selected: null,
  edit: '',
  useLocation: false,
};

const reducer: Reducer<AddressesState> = (state = initialState, action) => {
  switch (action.type) {
    case ADDRESSES_REQUEST:
      return {
        ...state,
        isLoading: true,
        searchError: null,
      };
    case ADDRESSES_SUCCESSFUL:
      return {
        ...state,
        isLoading: false,
        search: {
          keyword: action.payload.keyword,
          results: action.payload.results,
        },
        searchError: null,
      };
    case ADDRESSES_FAILURE:
      return {
        ...state,
        isLoading: false,
        searchError: action.payload,
      };
    case ADDRESSES_SELECT:
      return {
        ...state,
        lastSearch: action.payload.selected,
        selected: action.payload.selected,
        edit: action.payload.selected.formatted_address,
        useLocation: false,
      };
    case ADDRESSES_CLEAR_SELECT:
      return {
        ...state,
        selected: initialState.selected,
      };
    case ADDRESSES_EDIT:
      return {
        ...state,
        edit: action.payload.keyword,
      };
    case ADDRESSES_LOCATION:
      return {
        ...state,
        selected: action.payload.selected,
        edit: action.payload.keyword,
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

const migrations = {
  2: (state: any) => ({
    ...state,
    lastSearch: {
      ...initialState.lastSearch,
      ...state.lastSearch,
    },
    search: {
      ...initialState.search,
      ...state.search,
    },
  }),
};

const persistConfig = {
  storage,
  version: 2,
  key: 'addresses',
  blacklist: ['isLoading', 'error', 'search', 'edit'],
  migrate: createMigrate(migrations),
};

export default persistReducer(persistConfig, reducer);
